import { Component } from '@angular/core'
import { appConfig } from '../../../brands/_current/config/app-config'

@Component({
  selector: 'app-network-error-page',
  templateUrl: './network-error-page.component.html',
  styleUrls: ['./network-error-page.component.scss'],
})
export class NetworkErrorPageComponent {
  brandName = appConfig.core.brandName
  imagePath = appConfig.feedback.failure.networkImgBase64Src

  constructor() {}
}
